import "./Politicas.css";

export default function Devoluciones() {
  return (
    <div className="politicas-container">
      <h1>Política de Devoluciones y Cambios</h1>

      <h2>1. Plazo para solicitar devolución o cambio</h2>
      <p>
        El cliente tiene un plazo de cinco (5) días hábiles desde la entrega del producto para solicitar devolución o cambio. Este plazo corresponde al derecho de retracto y a las políticas internas de la tienda.
      </p>

      <h2>2. Condiciones del producto</h2>
      <ul>
        <li>Producto sin uso y en perfecto estado.</li>
        <li>Debe conservar su empaque original y accesorios.</li>
        <li>No aplica para productos digitales, personalizados o bajo oferta especial marcada como “No reembolsable”.</li>
      </ul>

      <h2>3. Tipos de cambios</h2>
      <ul>
        <li>Cambio por talla, color o referencia, sujeto a disponibilidad.</li>
        <li>Se permite un máximo de un (1) cambio por pedido.</li>
        <li>El cliente asume los costos de envío de devolución y reenvío.</li>
      </ul>

      <h2>4. Proceso</h2>
      <ul>
        <li>El cliente solicita la devolución o cambio desde su perfil o contacto de soporte.</li>
        <li>El administrador revisa la solicitud y aprueba o rechaza según las condiciones.</li>
        <li>Una vez recibido el producto en buen estado, se realiza el cambio o reembolso correspondiente.</li>
      </ul>

      <p>
        Nota: Para agilizar el proceso, siempre es recomendable incluir fotos o evidencia del producto en caso de defecto o daño.
      </p>
    </div>
  );
}
